import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/prestamo';
import Prestamo from './Prestamo';


const ms2p = (state) => {
  return {
    ...state.prestamo_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Prestamo);